export default {
  brandColor1: '#000000',
  complimentaryColor1: '#fff',
  brandColor2: '#FF2C2C',
  complimentaryColor2: '#fff',
};
